import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * GRW-30: disables every native control (buttons, inputs, selects, the Radix
 * triggers built on them) inside a panel when the viewer may not edit the
 * pursuit, so no create / edit / delete control is ever enabled for a reader
 * or on a merged stub. Links still navigate. `display: contents` keeps the
 * panel's own layout; with `readOnly` false it changes nothing.
 */ export function ReadOnlyScope({ readOnly, children }) {
    if (!readOnly) return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
    return /*#__PURE__*/ _jsx("fieldset", {
        className: "contents",
        disabled: true,
        children: children
    });
}
